var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panels',{staticClass:"painel-pai",attrs:{"multiple":""},model:{value:(_vm.valueOfList),callback:function ($$v) {_vm.valueOfList=$$v},expression:"valueOfList"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }